import {
  TOGGLE_USER_STATUS_REQUEST,
  TOGGLE_USER_STATUS_SUCCESS,
  TOGGLE_USER_STATUS_FAILURE,
} from "../Types";
import { apiGet } from "../../services/apiInterceptor";

export const toggleUserStatus = (id, action) => {
  return async (dispatch) => {
    dispatch({ type: TOGGLE_USER_STATUS_REQUEST });

    try {
      // ✅ MIGRATION : Plus besoin de gérer manuellement le token
      const response = await apiGet(`api/users/${id}/toggle?action=${action}`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(
          data?.message ||
            "Erreur lors de la mise à jour du statut de l'utilisateur."
        );
      }

      dispatch({ type: TOGGLE_USER_STATUS_SUCCESS, payload: data });
      // notification.success({
      //   message: data.message || "Statut de l'utilisateur mis à jour avec success",
      // });
      return data;
    } catch (error) {
      dispatch({ type: TOGGLE_USER_STATUS_FAILURE, payload: error?.message });
      // notification.error({
      //   message: error.message || "Erreur lors de la mise à jour du statut de l'utilisateur.",
      // });
    }
  };
};
